module.exports = __webpack_public_path__ + "media/assets/images/switch_language-0fa96a51dc2cbaf0cf520b4157539ee9.png";